module.exports = __webpack_public_path__ + "img/Call.81cb49f1.svg";